import { Component, OnInit } from "@angular/core";
import { AccountService } from "src/services/account.service";
import { MatLegacySnackBar as MatSnackBar } from "@angular/material/legacy-snack-bar";
import { Router } from "@angular/router";
import jwt_decode from "jwt-decode";
import { Helpers } from "src/helpers/helpers";
import { AgencyService } from "src/app/agency/services/agency.service";
import { Location } from "@angular/common";

@Component({
  selector: "app-change-password",
  templateUrl: "./change-password.component.html",
  styleUrls: ["./change-password.component.css"],
})
export class ChangePasswordComponent implements OnInit {
  pageTitle = "Change Password";
  confirmNewPassword: string;
  newPassword: string;
  currentPassword: string;
  isLoading = false;

  constructor(
    private accountService: AccountService,
    private agencyService: AgencyService,
    private snackBar: MatSnackBar,
    private router: Router,
    private helper: Helpers,
    private location: Location
  ) {
    const userType = this.helper.getDecodedAccessToken(
      window.localStorage.token
    ).type;
    if (
      userType.indexOf("LEVEL 0") === 0 ||
      userType.indexOf("LEVEL 1") === 0 ||
      userType.indexOf("LEVEL 2") === 0
    ) {
      this.accountService.getAccount().subscribe((data) => {
        if (!data.activated) {
          this.helper.logout();
          this.router.navigate(["/"]);
          this.snackBar.open(
            "Your account is not active, please contact admin.",
            "Close",
            {
              duration: 3000,
            }
          );
        }
      });
    }
  }

  ngOnInit() {}

  changePassword(form) {
    this.isLoading = true;
    const data = {
      currentPassword: form.value.currentPassword,
      newPassword: form.value.conformPasswordGroup.newPassword,
    };

    const obj = this.getDecodedAccessToken(this.helper.getToken());
    const userType = obj.type;
    if (
      userType.indexOf("LEVEL 0") === 0 ||
      userType.indexOf("LEVEL 1") === 0 ||
      userType.indexOf("LEVEL 2") === 0
    ) {
      this.agencyService.changePassword(data).subscribe(
        () => {
          this.isLoading = false;
          this.snackBar.open("Password changed successfully.", "CANCEL", {
            duration: 2000,
            horizontalPosition: "right",
          });
          this.back();
        },
        (err) => {
          this.isLoading = false;
          this.snackBar.open(err, "CANCEL", {
            horizontalPosition: "right",
          });
        }
      );
    } else {
      this.accountService.changePassword(data).subscribe(
        () => {
          this.isLoading = false;
          this.snackBar.open("Password changed successfully.", "CANCEL", {
            duration: 2000,
            horizontalPosition: "right",
          });
          this.back();
        },
        (err) => {
          this.isLoading = false;
          this.snackBar.open(err, "CANCEL", {
            horizontalPosition: "right",
          });
        }
      );
    }
  }

  getDecodedAccessToken(token: string): any {
    try {
      return jwt_decode(token);
    } catch (Error) {
      return null;
    }
  }

  back() {
    this.location.back();
  }
}
